export enum FeatureFlag {
  AI_ASSISTANT = 'genai_conversations_enabled',
  AI_ONBOARDING_ENABLED = 'ai-onboarding-enabled',
  ALLOWED_CUSTOM_COLUMNS = 'allowed-custom-columns',
  ALLOWED_CUSTOM_REPORTS = 'allowed-custom-reports',
  ALLOWED_TO_EDIT_ADMIN_TEAMS = 'allowed-to-edit-admin-teams',
  ALLOWED_TO_VIEW_ADDONS = 'allowed-to-view-addons',
  ALLOWED_TO_VIEW_INSIGHTS = 'allowed-to-view-insights',
  ALLOWED_TO_VIEW_PLUGINS = 'allowed-to-view-plugins',
  ALLOWED_TO_VIEW_POLICIES = 'allowed-to-view-policies',
  BLOCK_SYNCS = 'block-syncs',
  DATA_PERMISSIONS_AND_ROLES_ENABLED = 'data-permissions-and-roles-enabled',
  ENFORCE_TURNSTILE = 'enforce-turnstile',
  HIDE_ALL_DATA = 'hide-all-data',
  HIDE_DEVELOPER_MENU_FOR_NEW_SIGNUPS = 'cloud-hide-developer-menu-after-aug-25',
  MULTI_TENANT_PLATFORM_ALERTS_ENABLED = 'multi-tenant-platform-alerts-enabled',
  MULTI_TENANT_PLATFORM_PLUGIN_SYNC_RECOMMENDED_TABLES = 'multi-tenant-platform-plugin-sync-recommended-tables',
  PLATFORM_DISABLED_PLUGIN_UI = 'platform-disabled-plugin-ui',
  READONLY_USER_EDIT_DISABLED = 'readonly-user-edit-disabled',
  SYNC_FINALIZING_TIMEOUT_MINS = 'sync-finalizing-timeout',
}

export const turnstileFlagValues = {
  disabled: '',
  enforced: 'enforced',
  warn: 'warn',
} as const;

export const localFeatureFlagValues = {
  [FeatureFlag.AI_ASSISTANT]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.AI_ONBOARDING_ENABLED]: process.env.NODE_ENV === 'development' ? true : false,
  [FeatureFlag.ALLOWED_CUSTOM_COLUMNS]: {
    editing: process.env.NODE_ENV === 'development' ? true : false,
    enabled: process.env.NODE_ENV === 'development' ? true : false,
    externals: process.env.NODE_ENV === 'development' ? true : false,
  },
  [FeatureFlag.ALLOWED_CUSTOM_REPORTS]: {
    creating: process.env.NODE_ENV === 'development' ? true : false,
    editing: process.env.NODE_ENV === 'development' ? true : false,
  },
  [FeatureFlag.ALLOWED_TO_EDIT_ADMIN_TEAMS]:
    process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_ADDONS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_PLUGINS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_POLICIES]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_INSIGHTS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.DATA_PERMISSIONS_AND_ROLES_ENABLED]:
    process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ENFORCE_TURNSTILE]:
    process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_PLAYWRIGHT_TEST === 'true'
      ? turnstileFlagValues.enforced
      : turnstileFlagValues.disabled,
  [FeatureFlag.HIDE_ALL_DATA]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.HIDE_DEVELOPER_MENU_FOR_NEW_SIGNUPS]:
    process.env.NODE_ENV === 'development' ? 'false' : 'true',
  [FeatureFlag.PLATFORM_DISABLED_PLUGIN_UI]: '',
  [FeatureFlag.READONLY_USER_EDIT_DISABLED]:
    process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.SYNC_FINALIZING_TIMEOUT_MINS]: process.env.NODE_ENV === 'development' ? 60 : 0,
  [FeatureFlag.BLOCK_SYNCS]: process.env.NODE_ENV === 'development' ? false : true,
  [FeatureFlag.MULTI_TENANT_PLATFORM_ALERTS_ENABLED]:
    process.env.NODE_ENV === 'development' ? false : true,
  [FeatureFlag.MULTI_TENANT_PLATFORM_PLUGIN_SYNC_RECOMMENDED_TABLES]: {} as Record<
    string,
    string[]
  >,
} as const;
